import {
  canEditField,
  canPerform,
  hasPermission,
} from '../config/accessControl';
import { useAuth } from '../context/AuthContext';

function usePermissions() {
  const { user } = useAuth();

  return {
    can: (resource, action) => canPerform(user, resource, action),
    has: (permission) => hasPermission(user, permission),
    canEdit: (resource, field) => canEditField(user, resource, field),
  };
}

export default usePermissions;
